import { teachersData } from '../data/teachersData';
import { FaStar, FaUserGraduate, FaGlobe, FaAward } from 'react-icons/fa';
import './Teachers.css';

const Teachers = () => {
  return (
    <div className="teachers-page">
      <div className="teachers-hero">
        <div className="teachers-hero-overlay"></div>
        <div className="container">
          <div className="teachers-hero-content">
            <h1>Our Teachers</h1>
            <p>Meet our qualified and experienced Quran teachers</p>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="section-intro">
            <h2>Learn from the Best</h2>
            <p>
              Our teachers are carefully selected based on their knowledge, experience, and teaching abilities. 
              All our instructors are native Arabic speakers with proper Islamic education and teaching certifications.
            </p>
          </div>

          <div className="teachers-grid">
            {teachersData.map(teacher => (
              <div key={teacher.id} className="teacher-card">
                <div className="teacher-image">
                  <div className="image-placeholder">
                    <FaUserGraduate />
                  </div>
                  <div className="teacher-rating">
                    <FaStar /> {teacher.rating}
                  </div>
                </div>
                
                <div className="teacher-info">
                  <h3>{teacher.name}</h3>
                  <p className="teacher-title">{teacher.title}</p>
                  
                  <div className="teacher-meta">
                    <div className="meta-item">
                      <FaAward />
                      <span>{teacher.qualification}</span>
                    </div>
                    <div className="meta-item">
                      <FaUserGraduate />
                      <span>{teacher.experience} experience</span>
                    </div>
                    <div className="meta-item">
                      <FaGlobe />
                      <span>{teacher.language.join(', ')}</span>
                    </div>
                  </div>

                  <p className="teacher-description">{teacher.description}</p>

                  <div className="teacher-specialization">
                    <strong>Specialization:</strong>
                    <div className="tags">
                      {teacher.specialization.map((spec, index) => (
                        <span key={index} className="tag">{spec}</span>
                      ))}
                    </div>
                  </div>

                  <div className="teacher-stats">
                    <div className="stat">
                      <strong>{teacher.students}+</strong>
                      <span>Students Taught</span>
                    </div>
                    <div className="stat">
                      <strong>{teacher.rating}/5</strong>
                      <span>Rating</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="cta-section-inline">
            <h3>Want to Learn from Our Expert Teachers?</h3>
            <p>Start your journey with a free trial class today!</p>
            <a href="/free-trial" className="btn btn-secondary">Book Free Trial</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Teachers;
